export const Types = {
  GET_LIST_BORDEROS: "borderos/GET_LIST_BORDEROS",
  GET_LIST_BORDEROS_SUCCESS: "borderos/GET_LIST_BORDEROS_SUCCESS",
  GET_BORDEROS: "borderos/GET_BORDEROS",
  GET_BORDEROS_SUCCESS: "borderos/GET_BORDEROS_SUCCESS",
  EDIT_BORDEROS: "borderos/EDIT_BORDEROS",
  ADD_BORDEROS: "borderos/ADD_BORDEROS",
  DELETE_BORDEROS: "borderos/DELETE_BORDEROS",
  SEARCH_BORDEROS: "borderos/SEARCH_BORDEROS",
  CHANGE_PAGE_BORDEROS: "borderos/CHANGE_PAGE_BORDEROS",
  CHANGE_ROWS_PER_PAGE_BORDEROS: "borderos/CHANGE_ROWS_PER_PAGE_BORDEROS",
  GET_LIST_BORDEROS_SELECTS: "borderos/GET_LIST_BORDEROS_SELECTS",
  GET_LIST_BORDEROS_SUCCESS_SELECTS:
    "borderos/GET_LIST_BORDEROS_SUCCESS_SELECTS",
  PRINT: "borderos/PRINT",
  PRINT_SUCCESS: "borderos/PRINT_SUCCESS",
  DELETE_ALL_BORDEROS: "borderos/DELETE_ALL_BORDEROS",
  CHANGE_FILTER: "propostas/CHANGE_FILTER",
  GET_DOCS_PROPOSTAS_BORDERO: "borderos/GET_DOCS_PROPOSTAS_BORDERO",
  GET_DOCS_PROPOSTAS_BORDERO_SUCCESS: "borderos/GET_DOCS_PROPOSTAS_BORDERO_SUCCESS"
};

const INITIAL_STATE = {
  data: [],
  dataList: [],
  loadingSelect: false,
  item: {},
  propostas: {
    item: {}
  },
  filter: {},
  page: 0,
  rowsPerPage: localStorage.getItem("@ecorban-app:rows")
    ? parseInt(localStorage.getItem("@ecorban-app:rows"), 10)
    : 10,
  total: 0,
  print: ""
};

export default function borderos(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LIST_BORDEROS:
      return {...state};
    case Types.GET_LIST_BORDEROS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total
      };
    case Types.GET_BORDEROS_SUCCESS:
      return {
        ...state,
        item: action.payload.data
      };
    case Types.ADD_BORDEROS:
      return {...state};
    case Types.DELETE_BORDEROS:
      return {...state};
    case Types.CHANGE_PAGE_BORDEROS:
      return {...state, page: action.payload.page};
    case Types.SEARCH_BORDEROS:
      return {...state, filter: action.payload.filter};
    case Types.CHANGE_ROWS_PER_PAGE_BORDEROS:
      return {...state, rowsPerPage: action.payload.total};
    case Types.GET_LIST_BORDEROS_SELECTS:
      return {...state, loadingSelect: true};
    case Types.GET_LIST_BORDEROS_SUCCESS_SELECTS:
      return {
        ...state,
        dataList: action.payload.borderos,
        loadingSelect: false
      };
    case Types.PRINT_SUCCESS:
      return {...state, print: action.payload.url};
    case Types.DELETE_ALL_BORDEROS:
      return {...state};
    case Types.CHANGE_FILTER:
      return {
        ...state,
        filter: action.payload.data
      };
    case Types.GET_DOCS_PROPOSTAS_BORDERO_SUCCESS:
      return {
        ...state,
        propostas: {
          item: action.payload.data
        }
      };
    default:
      return state;
  }
}

export const Creators = {
  getListBorderos: () => ({
    type: Types.GET_LIST_BORDEROS
  }),
  getListBorderosSuccess: (data, total) => ({
    type: Types.GET_LIST_BORDEROS_SUCCESS,
    payload: {data, total}
  }),
  getBorderos: id => ({
    type: Types.GET_BORDEROS,
    payload: {id}
  }),
  getBorderosSuccess: data => ({
    type: Types.GET_BORDEROS_SUCCESS,
    payload: {data}
  }),
  editBorderos: data => ({
    type: Types.EDIT_BORDEROS,
    payload: data
  }),
  addBorderos: data => ({
    type: Types.ADD_BORDEROS,
    payload: data
  }),
  deleteBorderos: () => ({
    type: Types.DELETE_BORDEROS
  }),
  searchBorderos: filter => ({
    type: Types.SEARCH_BORDEROS,
    payload: {filter}
  }),
  changeBorderosPage: page => ({
    type: Types.CHANGE_PAGE_BORDEROS,
    payload: {page}
  }),
  changeBorderosRowsPerPage: total => ({
    type: Types.CHANGE_ROWS_PER_PAGE_BORDEROS,
    payload: {total}
  }),
  getListBorderosSelects: () => ({
    type: Types.GET_LIST_BORDEROS_SELECTS
  }),
  getListBorderosSuccessSelects: borderos => ({
    type: Types.GET_LIST_BORDEROS_SUCCESS_SELECTS,
    payload: {borderos}
  }),
  printBordero: id => ({
    type: Types.PRINT,
    payload: {id}
  }),
  printBorderoSuccess: url => ({
    type: Types.PRINT_SUCCESS,
    payload: {url}
  }),
  deleteAllBorderos: selected => ({
    type: Types.DELETE_ALL_BORDEROS,
    payload: {selected}
  }),
  changeFilter: data => ({
    type: Types.CHANGE_FILTER,
    payload: {data}
  }),
  getDocsPropostasBordero: id => ({
    type: Types.GET_DOCS_PROPOSTAS_BORDERO,
    payload: { id }
  }),
  getDocsPropostasBorderoSuccess: data => ({
    type: Types.GET_DOCS_PROPOSTAS_BORDERO_SUCCESS,
    payload: { data }
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/borderos.js